import { render, staticRenderFns } from "./ClientTransactionsSummary.vue?vue&type=template&id=7cda4223&scoped=true&"
import script from "./ClientTransactionsSummary.vue?vue&type=script&lang=js&"
export * from "./ClientTransactionsSummary.vue?vue&type=script&lang=js&"
import style0 from "./ClientTransactionsSummary.vue?vue&type=style&index=0&id=7cda4223&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cda4223",
  null
  
)

export default component.exports